/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Email_Not_ConfirmedInputs */

const nl_auth_api_errors_email_not_confirmed = /** @type {(inputs: Auth_Api_Errors_Email_Not_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres is niet bevestigd`)
};

/**

* @param {Auth_Api_Errors_Email_Not_ConfirmedInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_email_not_confirmed = /** @type {((inputs?: Auth_Api_Errors_Email_Not_ConfirmedInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Email_Not_ConfirmedInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_email_not_confirmed(inputs)
});
export { auth_api_errors_email_not_confirmed as "auth.api_errors.email_not_confirmed" }